import React, { useEffect, useState } from "react";
import "./BookingPopup.css";

function BookingPopup() {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {

    // Show popup after 15 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 15000);


    // Show popup again every 1 minute after being dismissed
    const repeatTimer = setInterval(() => {
      setIsVisible(true);
    }, 60000);


    return () => {

      clearTimeout(initialTimer);

      clearInterval(repeatTimer);

    };

  }, []);


  const handleIgnore = () => {

    setIsVisible(false);

  };


  if (!isVisible) {
    return null;
  }


  return (

    <div className="booking-popup-overlay">

      <div className="booking-popup">

        {/* CLOSE BUTTON */}

        <button
          className="booking-popup-close"
          onClick={handleIgnore}
          aria-label="Close booking popup"
        >
          ×
        </button>


        {/* CONTENT */}

        <div className="booking-popup-content">

          <span className="booking-popup-label">
            SATIMA TECHNOVA SOLUTIONS
          </span>


          <h2>
            Ready to Start Your Project?
          </h2>


          <p>
            Tell us what you need and let’s explore how we can help
            your business grow.
          </p>


          {/* BUTTONS */}

          <div className="booking-popup-actions">

            <a
              href="https://booking.satimatechnova.co.ke"
              className="booking-popup-book"
            >
              Book Now
            </a>


            <button
              type="button"
              onClick={handleIgnore}
              className="booking-popup-ignore"
            >
              Ignore
            </button>

          </div>

        </div>

      </div>

    </div>

  );

}


export default BookingPopup;